import { PageTypes } from '../constants/Pages.js';
import { SOURCE_UTM } from '../constants/misc.js';

var transporterUtmParamTypes;
(function (transporterUtmParamTypes) {
    transporterUtmParamTypes["WHAT_CAN_WE_DO"] = "what-can-we-do";
    transporterUtmParamTypes["OTHER_PROFILE"] = "other-profile";
})(transporterUtmParamTypes || (transporterUtmParamTypes = {}));
const transporterUtmParam = {
    [PageTypes.HOMEPAGE]: 0,
    [PageTypes.GROW_NETWORK]: 1,
    [transporterUtmParamTypes.WHAT_CAN_WE_DO]: 2,
    [transporterUtmParamTypes.OTHER_PROFILE]: 3
};
var marketplaceUtmParamTypes;
(function (marketplaceUtmParamTypes) {
    marketplaceUtmParamTypes["WHAT_CAN_WE_DO_LOAD"] = "what-can-we-do-load";
    marketplaceUtmParamTypes["WHAT_CAN_WE_DO_LORRY"] = "what-can-we-do-lorry";
})(marketplaceUtmParamTypes || (marketplaceUtmParamTypes = {}));
const marketplaceUtmParam = {
    [PageTypes.HOMEPAGE]: 0,
    [PageTypes.LOGISTICS_SERVICE]: 1,
    [PageTypes.ONLINE_LOAD_BOOKING]: 2,
    [PageTypes.ONLINE_TRUCK_BOOKING]: 3,
    [PageTypes.FULL_TRUCK_LOAD]: 4,
    [PageTypes.PART_LOAD_BOOKING]: 5,
    [marketplaceUtmParamTypes.WHAT_CAN_WE_DO_LOAD]: 6,
    [marketplaceUtmParamTypes.WHAT_CAN_WE_DO_LORRY]: 7
};
const getPageLoadSourceUTMParam = ({ urlQueryParams, utmParamObj }) => {
    for (const param in urlQueryParams) {
        if (param === SOURCE_UTM) {
            const paramValue = utmParamObj[urlQueryParams[param]];
            if (paramValue !== undefined) {
                return { value: paramValue };
            }
            return undefined;
        }
    }
};

export { getPageLoadSourceUTMParam, marketplaceUtmParam, marketplaceUtmParamTypes, transporterUtmParam, transporterUtmParamTypes };
//# sourceMappingURL=getPageLoadSourceUTMParam.js.map
